<app-transaction-result-view
[id]="id"
[shouldShowFlow]="true"
title="Nueva solicitud de licencia"
[subtitle]="subtitle"
[messageBold]="messageBold"
[message]="message"
[actionButtonText]="actionButtonText"
[actionButtonPath]="actionButtonPath"
secondaryButtonText="Crear una nueva solicitud"
secondaryButtonPath="/license/new"
[breadcrums]="breadcrums"
[actionButtonDescription]="actionButtonDescription"
[variant]="variant"
></app-transaction-result-view>
